"use client";
import * as React from "react";
const SvgContractFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.3 0c.54 0 .97.45.97 1v1.91h-1.42V1.45H1.92v13.1h8.52V16H1.47a1 1 0 0 1-.98-1V1a1 1 0 0 1 .98-1zM4.86 11.64a.7.7 0 0 1 .71.72.7.7 0 0 1-.7.73h-.82a.7.7 0 0 1-.71-.73.7.7 0 0 1 .7-.72zm7.63-8.08 3.01 3.09L14 8.19 10.99 5.1zm-4.6 2.9 2.1-.3 3 3.06-.29 2.17a.7.7 0 0 1-.56.61l-5.02 1.03a.72.72 0 0 1-.83-.86l1-5.14a.7.7 0 0 1 .6-.58m1.1 3.8a.7.7 0 0 0 1 0 .74.74 0 0 0 0-1.03.7.7 0 0 0-1 0 .74.74 0 0 0 0 1.03", clipRule: "evenodd" }));
export {
  SvgContractFilled as default
};
